/*jshint esversion: 6 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  
  state: {
    loggedIn: false,
    serverURL: "https://seriousgame2.epicflow.net/api",  
    // serverURL: "http://localhost:9090/api",

    manuallyPaused: true,
    Resources: {},
    comps: {
      admin: null,
    },
    simulationEvents: [],
    isAdmin: false,
    adminPanel: {
      selected: null,
      requestUpdateID: null,
      tab: 0,
    },
    durationValue: 500,
    speedIndex: 3,
    ResourceComponents: {},
    ResourceGroups: [{name: "Blue", color: "#00A1FF", id: "B"},
                      {name: "Orange", color: "#FEAE00", id: "O"},
                      {name: "Indigo", color: "#004D80", id: "I"},
                      {name: "Maroon", color: "#A33D32", id: "M"},
                      {name: "Aqua", color: "#16E7CF", id: "A"},
                      {name: "Pink", color: "#FF42A1", id: "P"}],
    DraggingResource: null,
    DraggingClone: null,
    workerWidth: 0,
    workerHeight: 0,
    hoursPassed: 0,
    validPlace: false,
    Simulations: require('./SimulationParams.json'),
    SimInfo: {SimName: "", AutoMode: ""},
    CurrSimulation: null,
    mounted: false,
    transform: null,
    dashboard: {
      slider: 0,

    },
    graphs: {
      graphTab: 0,
      waitingTimeCheckBoxes: {B: true, O: true, I: true, M: true, A: true, P: true},
      futureLoadCheckBoxes: {B: true, O: true, I: true, M: true, A: true, P: true},
      averageLoadCheckBoxes: {B: true, O: true, I: true, M: true, A: true, P: true},
      historicalLoadCheckBoxes: {B: true, O: true, I: true, M: true, A: true, P: true},
      historicalLineCheckBoxes: {capacity: true, spent: true, output: true, averageload: true},
    },
    SimulationOptions: {"Gantt": "Gantt", "DueDate": "Due Date", "EpicFlow": "EpicFlow"}, //, "EpicFlowV2": "EpicFlowV2", "STAM": "STAM", "Features": "Features"},
    metrics: [{"FinishedProjects": 0, "DueDatePerformance": 0, "Flow": 0, "CurrProjectOnTime": 0, "CurrProjectTooLate": 0, "ProjectRevenue": 0, "LaborCost": 0,  "LaborHours": 0, "PenaltyCost": 0, "TotalCost": 0, "Load": {"B": 0, "O": 0, "I": 0, "M": 0, "A": 0, "P": 0}, "CurrWorking": {"Blue": 0, "Orange": 0, "Indigo": 0, "Maroon": 0, "Aqua": 0, "Pink": 0}}],
    events: [],
    AllProjects: require('./ProjectParams.json'),
  },
  mutations: {
  },
  getters: {
    getSimulationFromName: (state) => (simulationName) => {
      const simPredicate = (currSimulation) => currSimulation.Simulation_Name == simulationName;
      return state.Simulations.find(simPredicate);
    },

    eventToIcon: (state) => (event) => {
      if(event.type == "startHire" || event.type == "finishHire"){
        return "mdi-account-multiple-plus";
      }
      if(event.type == "startFire" || event.type == "finishFire"){
        return "mdi-account-multiple-minus";
      }

      if(event.type == "cancelFire" || event.type == "cancelHire"){
        return "mdi-close-circle";
      }

      if(event.type == "startTrain" || event.type == "finishTrain"){
        return "mdi-account-switch";
      }
    },

    eventToText: (state, getters) => (event) => {
      if (event.type == "assignTask") {
        return "Assigned to task " + event.taskID + " of project index " + event.projectIndex;
      }
      if (event.type == "startHire") {
        return event.groupName + " started hiring a resource"  + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "startFire") {
        return event.groupName + " started firing a resource" + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "cancelFire") {
        return event.groupName + " cancelled firing a resource" + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "cancelHire") {
        return event.groupName + " cancelled hiring a resource" + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "finishFire") {
        return event.groupName + " finished firing a resource" + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "finishHire") {
        return event.groupName + " finished hiring a resource" + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "startTrain") {
        return event.groupName + " started training for resource " + event.alternateGroupName + " at " + getters.hourToString(event.hour);
      }
      if (event.type == "finishTrain") {
        return event.groupName + " finished training for resource " + event.alternateGroupName + " at " + getters.hourToString(event.hour);
      }
    },
    hourToString: (state) => (hour) => {
      var day = Math.floor(hour / 8);
      var remainingHours = hour - day * 8;

      return `Day ${day} hour ${remainingHours}`
    },

  },
  actions: {
  },
  modules: {
  }
})
